import { render, staticRenderFns } from "./VerifyIdentityError.vue?vue&type=template&id=2dd0a142"
import script from "./VerifyIdentityError.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports